// src/utils/dateUtils.js

export const convertToInputDateFormat = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return "";
  return date.toISOString().split("T")[0]; // 返回 YYYY-MM-DD 格式
};


export const formatDateForDisplay = (dateString) => {
  if (!dateString) return "N/A";


  if (typeof dateString === "string" && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = dateString.split("-");
    const monthShort = new Date(`${year}-${month}-01`).toLocaleString("en-US", { month: "short" });
    return `${day}-${monthShort}-${year}`;
  }


  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "N/A";

  const day = String(date.getDate()).padStart(2, "0");
  const monthShort = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${day}-${monthShort}-${year}`;
};
